<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-header-txt">{{$t('edit_shortcuts')}}</span>
          <span class="modal-header-description">
              {{$t('see_on_the_home')}}
            </span>
        </div>

        <div class="shortcut-list">
          <div class="shortcut-item" v-for="item in shortcuts" @click="toggleShortcut(item.id)" :key="item.id">
            <div class="shortcut-left">
              <div class="checkbox-wrapper">
                <img src="@/assets/images/checkboxChecked.svg" v-if="selectedShortcuts.includes(item.id)" width="18" height="18" />
                <img src="@/assets/images/checkbox.svg" v-else width="18" height="18" />
              </div>

              <img :src="icon(item?.iconRef)" alt="card icon" class="card-icon" width="36" height="36" />

              <div class="shortcut-info">
                <span class="shortcut-title">{{ item.title }}</span>
                <span class="shortcut-description">{{ item.description }}</span>
              </div>
            </div>

            <div class="shortcut-right">
              <div class="tag" :class="item?.tagColor" v-if="item?.tagColor && item?.tagText && item?.tagText !== ''">
                <span>{{ item.tagText }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="cancel-btn" @click="handleCancel">{{ $t('cancel') }}</button>
          <button class="add-btn" @click="handleAdd">{{ $t('add') }}</button>
        </div>

        <div @click="handleCancel" class="close-btn">
          <img class="cross" src="../../assets/images/cross.svg" />
        </div>

      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    icons: {
      type: Object,
      default: () => ({})
    },
    shortcuts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedShortcuts: []
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadSelectedShortcuts();
      }
    }
  },
  created() {
    this.loadSelectedShortcuts();
  },
  methods: {
    loadSelectedShortcuts() {
      try {
        const localStorageCards = JSON.parse(localStorage.getItem('mainCards')) || [];
        this.selectedShortcuts = [...localStorageCards];
      } catch (error) {
        this.selectedShortcuts = [];
      }
    },
    toggleShortcut(id) {
      const index = this.selectedShortcuts.indexOf(id);

      if (index !== -1) {
        this.selectedShortcuts.splice(index, 1);
      } else {
        this.selectedShortcuts.push(id);
      }
    },
    handleAdd() {
      localStorage.setItem('mainCards', JSON.stringify(this.selectedShortcuts));

      this.$emit('update-shortcuts', this.selectedShortcuts);

      this.onHide();
    },
    handleCancel() {
      this.onHide();
    },
    icon(iconRef) {
      return this.icons[iconRef] || this.icons.addFill;
    }
  },
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  padding-bottom: 100px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}
.cross{
  padding: 8px;
}
.modal-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}
.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}
.modal-header-description {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.shortcut-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #EAECF0;
  cursor: pointer;
}

.shortcut-item:hover {
  background-color: #F9FAFB;
}

.shortcut-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.shortcut-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.shortcut-title {
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  color: #101828;
}

.shortcut-description {
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #475467;
}

.modal-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background-color: #fff;
  border-top: 1px solid #EAECF0;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
</style>
